// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metadata } from './Metadata';
import {
  MetadataFromJSON,
  MetadataFromJSONTyped,
  MetadataToJSON,
  MetadataToJSONTyped,
} from './Metadata';
import type { ClusterSpec } from './ClusterSpec';
import {
  ClusterSpecFromJSON,
  ClusterSpecFromJSONTyped,
  ClusterSpecToJSON,
  ClusterSpecToJSONTyped,
} from './ClusterSpec';
import type { ClusterStatus } from './ClusterStatus';
import {
  ClusterStatusFromJSON,
  ClusterStatusFromJSONTyped,
  ClusterStatusToJSON,
  ClusterStatusToJSONTyped,
} from './ClusterStatus';

/**
 *
 * @export
 * @interface ClusterEntity
 */
export interface ClusterEntity {
  /**
   *
   * @type {string}
   * @memberof ClusterEntity
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterEntity
   */
  environment?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterEntity
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterEntity
   */
  managementSource?: string;
  /**
   *
   * @type {Metadata}
   * @memberof ClusterEntity
   */
  metadata?: Metadata;
  /**
   *
   * @type {ClusterSpec}
   * @memberof ClusterEntity
   */
  spec?: ClusterSpec;
  /**
   *
   * @type {ClusterStatus}
   * @memberof ClusterEntity
   */
  status?: ClusterStatus;
  /**
   *
   * @type {string}
   * @memberof ClusterEntity
   */
  updatedAt?: string;
}

/**
 * Check if a given object implements the ClusterEntity interface.
 */
export function instanceOfClusterEntity(value: object): value is ClusterEntity {
  return true;
}

export function ClusterEntityFromJSON(json: any): ClusterEntity {
  return ClusterEntityFromJSONTyped(json, false);
}

export function ClusterEntityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterEntity {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    environment: json['environment'] == null ? undefined : json['environment'],
    id: json['id'] == null ? undefined : json['id'],
    managementSource:
      json['management_source'] == null ? undefined : json['management_source'],
    metadata:
      json['metadata'] == null ? undefined : MetadataFromJSON(json['metadata']),
    spec: json['spec'] == null ? undefined : ClusterSpecFromJSON(json['spec']),
    status:
      json['status'] == null
        ? undefined
        : ClusterStatusFromJSON(json['status']),
    updatedAt: json['updated_at'] == null ? undefined : json['updated_at'],
  };
}

export function ClusterEntityToJSON(json: any): ClusterEntity {
  return ClusterEntityToJSONTyped(json, false);
}

export function ClusterEntityToJSONTyped(
  value?: ClusterEntity | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    created_at: value['createdAt'],
    environment: value['environment'],
    id: value['id'],
    management_source: value['managementSource'],
    metadata: MetadataToJSON(value['metadata']),
    spec: ClusterSpecToJSON(value['spec']),
    status: ClusterStatusToJSON(value['status']),
    updated_at: value['updatedAt'],
  };
}
